/* creo-misura.js — come usano il configuratore (3 settembre 2026)
 *
 * File a parte: NON tocca creo-configuratore.js. Legge lo stato dal hash
 * dell'indirizzo (#m=…&f=…&st=…) che il motore riscrive a ogni scelta, ascolta
 * i clic sul pannello, intercetta /cart/add.js e l'errore di variante, e manda
 * gli eventi a creopositano.pages.dev/api/misura (Cloudflare Pages + D1).
 *
 * Niente cookie, niente dato personale, niente IP salvato: l'identificativo di
 * sessione e' casuale, vive in sessionStorage e muore con la scheda.
 * Il banco in bottega (?banco=…) viene marcato, cosi' si tiene fuori dai conti.
 */
(function () {
  'use strict';
  if (window.__creoMisura) return;
  window.__creoMisura = 1;

  var URL_API = 'https://creopositano.pages.dev/api/misura';
  var CAMPI = { m: 'modello', f: 'forma', st: 'stile', a: 'aste', n: 'interno', k: 'costruzione',
    l: 'lente', p: 'polarizzata', c: 'calibro', b: 'ponte', u: 'asta', s: 'sorgente', q: 'custodia', i: 'incisione' };
  var t0 = Date.now();
  var sec = function () { return Math.round((Date.now() - t0) / 10) / 100; };

  // ---- sessione ----
  var sid = '';
  try { sid = sessionStorage.getItem('creo_ms') || ''; } catch (e) { }
  if (!sid) {
    sid = Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
    try { sessionStorage.setItem('creo_ms', sid); } catch (e) { }
  }
  var banco = /[?&]banco=/.test(location.search) ? 1 : 0;
  var lingua = (window.CREO_CFG && CREO_CFG.lang) || document.documentElement.lang || '';
  var largh = window.innerWidth || 0;
  var device = (navigator.maxTouchPoints > 0 && largh <= 820) ? 'mobile' : (navigator.maxTouchPoints > 0 ? 'tablet' : 'desktop');
  var sorgente = '';
  try { sorgente = document.referrer ? new URL(document.referrer).host.replace(/^www\./, '') : ''; } catch (e) { }
  if (/creopositano\.com$|positanoglasses\.com$/.test(sorgente)) sorgente = 'sito';

  // ---- coda ed invio ----
  var coda = [], timer = null, ultimoCampo = '';
  function pacchetto() {
    return JSON.stringify({ s: sid, l: lingua, d: device, w: largh, b: banco, r: sorgente, ev: coda.splice(0, 50) });
  }
  function invia(beacon) {
    if (!coda.length) return;
    var corpo = pacchetto();
    try {
      if (beacon && navigator.sendBeacon) {
        // text/plain: niente preflight CORS, arriva anche mentre la pagina chiude
        navigator.sendBeacon(URL_API, new Blob([corpo], { type: 'text/plain' }));
      } else {
        fetch(URL_API, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: corpo, keepalive: true }).catch(function () { });
      }
    } catch (e) { }
    if (coda.length) invia(beacon);
  }
  function ev(tipo, campo, prima, dopo, extra) {
    coda.push({ t: tipo, c: campo || '', p: prima == null ? '' : String(prima).slice(0, 80),
      d: dopo == null ? '' : String(dopo).slice(0, 80), s: sec(), x: extra ? String(extra).slice(0, 200) : '' });
    if (coda.length >= 20) invia();
    else if (!timer) timer = setTimeout(function () { timer = null; invia(); }, 4000);
  }

  // ---- stato dal hash ----
  function leggi() {
    var o = {}, h = location.hash.replace(/^#/, '');
    if (!h) return o;
    h.split('&').forEach(function (kv) {
      var i = kv.indexOf('='); if (i < 0) return;
      var k = kv.slice(0, i), v = kv.slice(i + 1);
      if (CAMPI[k]) { try { v = decodeURIComponent(v); } catch (e) { } o[k] = v; }
    });
    return o;
  }
  // il motore scrive il suo progetto di partenza nel hash prima che questo file
  // (defer) parta: per sapere se il cliente e' ARRIVATO con un link si guarda
  // il hash catturato inline dallo snippet, non quello di adesso
  var hash0 = typeof window.__creoHash0 === 'string' ? window.__creoHash0 : location.hash;
  var avviato = /(^|[#&])m=/.test(hash0);
  var stato = leggi();

  /* 6/10: da quale ingresso della scheda prodotto si arriva (foto, prezzo,
     carrello): va nel campo «prima» dell'apertura, senza un tipo nuovo */
  var da = ((location.search.match(/[?&]da=([a-z0-9_-]{1,20})/i) || [])[1] || '').toLowerCase();
  ev('apertura', avviato ? 'link' : 'nuovo', da, avviato ? ((hash0.match(/(?:^|[#&])m=([^&]*)/) || [])[1] || '') : '', location.pathname);

  /* 🆕 4/10/2026 · QUALE CONFIGURATORE. Dal 4/10 il configuratore del sito e'
     la versione a gesti (creo-snap.js); il classico resta per il banco. Ogni
     volta che si passa dall'uno all'altro parte un evento 'versione' (campo
     'snap' o 'classico'), e nella versione a gesti la sezione in cui si e'
     (Forma, Misura, Materiali...) diventa un 'passo' come i passi del
     classico. Si legge dalla pagina, senza toccare creo-snap.js. */
  var versione = '', sezioneSnap = '';
  function guardaVersione() {
    var v = document.documentElement.classList.contains('creo-snap-on') ? 'snap' : 'classico';
    if (v !== versione) {
      // il classico all'avvio dura il tempo di caricare la versione a gesti:
      // lo si scrive solo se resta (al secondo giro) o se si torna indietro
      if (!(v === 'classico' && !versione && sec() < 6)) { ev('versione', v, versione, ''); versione = v; }
    }
    if (v === 'snap') {
      var on = document.querySelector('.creo-snap__rail button.on, .creo-snap__rail [aria-current="true"]');
      var nome = on ? (on.textContent || '').trim().slice(0, 40) : '';
      if (nome && nome !== sezioneSnap) { ev('passo', nome, 'apri', 'snap'); sezioneSnap = nome; }
    }
  }
  setInterval(function () {
    guardaVersione();
    var n = leggi(), k;
    if (!Object.keys(stato).length && Object.keys(n).length) {
      // il motore ha appena scritto i suoi valori di partenza: e' l'inizio, non una scelta
      ev('inizio', 'modello', '', n.m || '', location.hash.slice(1, 200));
      stato = n;
      return;
    }
    for (k in CAMPI) {
      if ((n[k] || '') !== (stato[k] || '')) {
        // le maniglie (f=) e le misure cambiano a raffica: si registra il campo, non ogni tacca
        if (stato[k] !== undefined || n[k]) {
          ev('scelta', CAMPI[k], stato[k], n[k]);
          ultimoCampo = CAMPI[k];
        }
      }
    }
    stato = n;
  }, 500);

  // ---- clic sul pannello: passi aperti e bottoni ----
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button, a') : null;
    if (!b) return;
    var cls = b.className && typeof b.className === 'string' ? b.className : '';
    if (cls.indexOf('creo-cfg__famh') >= 0) {
      var t = b.querySelector('.creo-cfg__famt');
      var fam = b.closest('.creo-cfg__fam');
      ev('passo', (t ? t.textContent : '').trim().slice(0, 40), fam && fam.classList.contains('is-open') ? 'chiudi' : 'apri', '');
      return;
    }
    if (cls.indexOf('creo-cfg__share') >= 0) { ev('azione', 'condividi'); return; }
    if (cls.indexOf('creo-cfg__print') >= 0) { ev('azione', 'stampa'); return; }
    if (cls.indexOf('creo-cfg__cta') >= 0) { ev('azione', 'carrello_clic', '', '', location.hash.slice(1, 200)); return; }
    /* la versione a gesti: i suoi bottoni hanno nomi suoi */
    var snap = cls.match(/creo-snap__(ind|dado|avanti|cta|foto|chiudi|aiuto|pmisura|scatto|fine|gchiudi|pchiudi|ptorna)\b/);
    if (snap) {
      var nomi = { ind: 'indossa', dado: 'dadi', avanti: 'avanti', cta: 'carrello_clic', foto: 'foto', chiudi: 'chiudi',
        aiuto: 'aiuto', pmisura: 'misura_carta', scatto: 'foto', fine: 'modifica_selettiva', gchiudi: 'chiudi_griglia',
        pchiudi: 'chiudi_secondo_passo', ptorna: 'torna_a_modificare' };
      var az = nomi[snap[1]];
      ev('azione', az, 'snap', '', az === 'carrello_clic' ? location.hash.slice(1, 200) : '');
      return;
    }
    if (/creo-snap__it\b/.test(cls) && b.classList.contains('is-sel')) { ev('azione', 'griglia', 'snap'); return; }
    if (/creo-cfg__(caso|pop|cambia|mini)|creo-x__/.test(cls)) {
      ev('azione', cls.split(' ')[0].replace(/^creo-/, ''), '', (b.textContent || '').trim().slice(0, 30));
    }
  }, true);

  // ---- carrello: la chiamata vera e la rete che la rifiuta ----
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (u, o) {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/add\.js/.test(url) && o && o.method === 'POST') {
        var prezzo = '';
        try {
          var pr = versione === 'snap' ? document.querySelector('.creo-snap__paga .tot, .creo-snap__prezzo') : document.querySelector('.creo-cfg__prezzo');
          prezzo = pr ? pr.textContent.trim() : '';
        } catch (e) { }
        p.then(function (r) {
          ev(r.ok ? 'carrello' : 'carrello_errore', String(r.status), prezzo, stato.m || '', location.hash.slice(1, 200));
          invia();
        }, function () { ev('carrello_errore', 'rete', prezzo, stato.m || ''); invia(); });
      }
      return p;
    };
  }
  if (window.console && console.error) {
    var _err = console.error;
    console.error = function () {
      try {
        var m = String(arguments[0] || '');
        if (m.indexOf('CREO carrello') === 0) { ev('carrello_rotto', '', '', '', m); invia(); }
      } catch (e) { }
      return _err.apply(console, arguments);
    };
  }

  // ---- uscita ----
  var uscito = false;
  function uscita() {
    if (uscito) return; uscito = true;
    ev('uscita', ultimoCampo, '', stato.m || '', location.hash.slice(1, 200));
    invia(true);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { uscita(); } else { uscito = false; ev('ritorno'); }
  });
  window.addEventListener('pagehide', uscita);
})();
